module.exports = __webpack_public_path__ + "img/elementwidths_jakp.ee8912e1.png";